import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const AccountCreateModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    submitted, createAccountMode,
    // event handlers
    onSubmit, onCancelClick,
    //
    panNumber, onpanNumberChange, panNumberError, setpanNumberError,
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Add Account Using PAN'
        buttonLabel='Add'
        cancelLabel='Cancel'
        isOpen={createAccountMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='panNumber' label='PAN Number'
            required={true} maxLength={100} autoFocus={true}
            value={panNumber} onChange={onpanNumberChange}
            error={panNumberError} setError={setpanNumberError}
        />
    </ModalFormUI>

export default AccountCreateModalUI
